import React, { useState } from 'react';
import { DefaultModal } from '@/presentation/components';
import Styles from './avatar-modal-styles.scss';
import { AvatarCreator } from '@readyplayerme/rpm-react-sdk';
import { ErrorBoundary } from 'react-error-boundary';
import RenderAvatar from './render-avatar';
const AvatarModal = ({ openModal, setOpenModal, handleOnAvatarExported: handleOnAvatarExportedParam }) => {
    const [avatarUrl, setAvatarUrl] = useState(null);
    const handleOnAvatarExported = (url) => {
        console.log(`Avatar URL is: ${url}`);
        // const id = extractAvatarIdFromUrl(url);
        setAvatarUrl(url);
        handleOnAvatarExportedParam(url);
    };
    return (React.createElement(DefaultModal, { height: "99", hUnit: "vh", width: "99", wUnit: "vw", open: openModal, onClose: () => setOpenModal(false), overlayCustomStyles: { zIndex: 9999 }, showClose: true, padding: "56px 10px 10px 10px" },
        React.createElement("div", { className: Styles.mainWrap }, avatarUrl ? (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                background: 'radial-gradient(rgba(0, 163, 255, 0.6), #7F1BFF)',
                borderRadius: '25px'
            } },
            React.createElement(RenderAvatar, { avatarUrl: avatarUrl }))) : (React.createElement(AvatarCreator, { subdomain: "kidvestors", onAvatarExported: handleOnAvatarExported, 
            // onUserSet={handleOnUserSet}
            editorConfig: {
                bodyType: 'fullbody',
                clearCache: true,
                quickStart: false
            } })))));
};
const logError = (error, info) => {
    console.log('Error boundary error: ', error, info);
};
const AvatarModalWrapper = (props) => {
    if (props.openModal) {
        return (React.createElement(ErrorBoundary, { fallback: React.createElement("div", { style: { width: '100%', textAlign: 'center', color: 'red' } },
                React.createElement("b", null, "Something went wrong")), onError: logError },
            React.createElement(AvatarModal, Object.assign({}, props))));
    }
    return null;
};
export default AvatarModalWrapper;
